import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";

import PaymentTerminalForm from "../PaymentTerminalForm";

import { usePaymentTerminalAdd } from "./hooks";

const PaymentTerminalAdd: React.FC = () => {
  const { form } = usePaymentTerminalAdd();

  return (
    <>
      <Typography.Title>
        <FormattedMessage defaultMessage="Add Payment Terminal" />
      </Typography.Title>
      <Space />
      <PaymentTerminalForm {...form} />
    </>
  );
};

export default PaymentTerminalAdd;
